module.exports = __webpack_public_path__ + "static/img/1-1.ee23fff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/1-1.png
// module id = BGSE
// module chunks = 0